export const DeleteMessage = {
    deleteSubmitted:
        'Are you sure you want to delete this worksheet? Please note that to submit a case,a case type and its corresponding worksheet must be filled with required information.',
    deleteRemaining: 'Are you sure you want to delete this worksheet?',
};
